import { motion } from "framer-motion";
import { Award, Leaf, ChefHat, HandHeart, MapPin, Recycle } from "lucide-react";

const engagements = [
  { icon: Award, titre: "Qualité artisanale", desc: "Un travail minutieux à chaque étape, pour un produit d'exception sans compromis." },
  { icon: Leaf, titre: "Élevage responsable", desc: "Le respect du cycle naturel de l'escargot et un environnement sain et préservé." },
  { icon: ChefHat, titre: "Fabrication maison", desc: "Élevage, transformation et cuisson entièrement réalisés sur notre exploitation." },
  { icon: Recycle, titre: "Circuit court", desc: "Une relation directe et de confiance avec nos clients, du producteur à l'assiette." },
  { icon: MapPin, titre: "Terroir bourguignon", desc: "Un ancrage fort dans la gastronomie et les traditions de la Bourgogne." },
  { icon: HandHeart, titre: "Savoir-faire familial", desc: "Une passion transmise et partagée en famille, au service du goût et de l'authenticité." },
];

const Engagements = () => {
  return (
    <section data-testid="engagements-section" id="engagements" className="py-24 lg:py-32 bg-sable">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm uppercase tracking-[0.3em] text-mousse font-500">Notre exigence</span>
          <h2 className="font-heading text-4xl sm:text-5xl text-foreground mt-2 tracking-tight">Nos engagements</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {engagements.map((e, i) => {
            const Icon = e.icon;
            return (
              <motion.div
                key={e.titre}
                data-testid={`engagement-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group p-8 rounded-2xl bg-creme border border-border hover:border-bordeaux/40 transition-colors"
              >
                <div className="w-14 h-14 rounded-xl bg-bordeaux/10 flex items-center justify-center text-bordeaux group-hover:bg-bordeaux group-hover:text-white transition-colors">
                  <Icon size={26} />
                </div>
                <h3 className="font-heading text-2xl text-foreground mt-5">{e.titre}</h3>
                <p className="text-foreground/70 mt-3 leading-relaxed">{e.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Engagements;
